export default "__VITE_ASSET__By6bAknS__"